import { platformHttp } from '@/utils/http'
import Global from '@/global'

// 存储服务相关的 API
const apis = {
  uploadFile: '/api/storage/save'
}

export function uploadFile(formData, onUploadProgress) {
  return platformHttp.post(apis.uploadFile, formData, {
    isTransformRequestResult: false,
    headers: { 'content-type': 'multipart/form-data' },
    params: { _id: Global.genNonce(5) },
    onUploadProgress
  }).then(data => data.url)
}
